import { MenuItem, TextField } from "@mui/material";
import themeColorsDesingSystem from "assets/theme/ds-colors";

export default function SelectField({
  disabled,
  required,
  value,
  onChange,
  options,
  label,
  width,
  ...props
}) {
  return (
    <TextField
      select
      label={label}
      value={value}
      onChange={onChange}
      disabled={disabled}
      required={required}
      variant="outlined"
      sx={{
        width: width,
        minWidth: "100px",
        "& .MuiOutlinedInput-root": {
          borderColor: themeColorsDesingSystem.stone.medium,
          "&.Mui-focused fieldset": {
            borderColor: themeColorsDesingSystem.stone.medium,
            borderWidth: "1px",
          },
          "&:hover fieldset": {
            borderColor: themeColorsDesingSystem.primary.main,
          },
          "&.Mui-disabled": {
            backgroundColor: themeColorsDesingSystem.stone.light,
            cursor: "default",
          },
        },
        "& .MuiInputBase-input": {
          fontFamily: "Open Sans,sans-serif",
          color: themeColorsDesingSystem.text.primary,
          fontSize: ".875rem",
          padding: "7px 40px 8px 10px!important",
        },
        "& .MuiIconButton-root": {
          padding: 0,
        },
      }}
      {...props}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
}
